var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastUpdate && _vm.lastUpdate.length)?_c('div',[_vm._v("\n    Última actualización: "),_c('strong',[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.lastUpdate)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }